import { UploadFileInfo } from '@interfaces/panel/files';
import { User } from '@interfaces/user/users';
import { CustomQueryModel } from '@models/query/queries';
import { UserDataModel } from '@models/user/data';
import { ChangePasswordModel } from '@models/users';
import IService from './iService';

export default class UserService extends IService {
    async fetchUserData() {
        return await this.getApi<User>('/api/account/info/');
    }

    async patchUserData(user: UserDataModel) {
        return await this.patchApi('/api/account/info/', user);
    }

    async fetchUserBalance(): Promise<number> {
        return await this.getAndThrowApi<number>('/api/account/balance/');
    }

    async changeUserPassword(data: ChangePasswordModel) {
        return await this.patchApi('/api/account/password/', data);
    }

    async executeCustomQuery<T = any>(query: CustomQueryModel) {
        return await this.postApi<T>('/query/', query);
    }

    async prepareAvatarUpload() {
        return await this.patchApi<UploadFileInfo>('/api/account/avatar/');
    }

    async updateUserLanguage(language: string) {
        return this.patchApi('/api/account/language/', { language });
    }
}